import { render, staticRenderFns } from "./journalsLogin.vue?vue&type=template&id=1837d9cc&scoped=true"
import script from "./journalsLogin.vue?vue&type=script&lang=js"
export * from "./journalsLogin.vue?vue&type=script&lang=js"
import style0 from "./journalsLogin.vue?vue&type=style&index=0&id=1837d9cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1837d9cc",
  null
  
)

export default component.exports